/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_Support_HeadingInputs */

const en_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other Brave support topics`)
};

const id_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topik dukungan Brave lainnya`)
};

const ms_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topik-topik Brave support yang lain`)
};

const ca_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altres temes d'assistència de Brave`)
};

const cs_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatní témata podpory Brave`)
};

const da_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andre Brave-hjælpeemner`)
};

const de_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Support-Themen zu Brave`)
};

const et_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muud Brave'i kasutajatoe teemad`)
};

const es_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros temas de ayuda con Brave`)
};

const fr_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres sujets`)
};

const hr_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostale teme podrške Brave`)
};

const it_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altri articoli di supporto di Brave`)
};

const lv_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citas Brave atbalsta tēmas`)
};

const lt_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitos „Brave“ palaikymo temos`)
};

const hu_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéb Brave súgótémák`)
};

const nl_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Brave-ondersteuningsonderwerpen`)
};

const nb_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andre emner fra brukerstøtte`)
};

const pl_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inne tematy dotyczące wsparcia Brave`)
};

const pt_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outros tópicos de Suporte do Brave`)
};

const ro_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alte subiecte de asistență Brave`)
};

const sk_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ďalšie témy podpory Brave`)
};

const sl_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druge teme podpore za Brave`)
};

const fi_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muut Braven tukiaiheet`)
};

const sv_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andra Brave support-ämnen`)
};

const vi_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các chủ đề hỗ trợ khác của Brave`)
};

const tr_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer Brave destek konuları`)
};

const el_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Άλλα θέματα υποστήριξης του Brave`)
};

const bg_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Други теми за поддръжка на Brave`)
};

const ru_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другие темы поддержки Brave`)
};

const sr_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Друге теме подршке за Brave`)
};

const uk_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Інші теми підтримки Brave`)
};

const ka_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave-ის მხარდაჭერის სხვა საკითხები`)
};

const hi_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्य ब्रेव सपोर्ट टॉपिक्स`)
};

const th_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หัวข้อการสนับสนุนอื่น ๆ ของ Brave`)
};

const ko_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기타 Brave 지원 주제`)
};

const zh_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他 Brave 支持主题`)
};

const zh_tw_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他 Brave 支援主題`)
};

const ja_other_support_heading = /** @type {(inputs: Other_Support_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braveについてその他のサポートトピック`)
};

/**
* | output |
* | --- |
* | "Other Brave support topics" |
*
* @param {Other_Support_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const other_support_heading = /** @type {((inputs?: Other_Support_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_Support_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_other_support_heading(inputs)
	if (locale === "ms") return ms_other_support_heading(inputs)
	if (locale === "ca") return ca_other_support_heading(inputs)
	if (locale === "cs") return cs_other_support_heading(inputs)
	if (locale === "da") return da_other_support_heading(inputs)
	if (locale === "de") return de_other_support_heading(inputs)
	if (locale === "et") return et_other_support_heading(inputs)
	if (locale === "es") return es_other_support_heading(inputs)
	if (locale === "fr") return fr_other_support_heading(inputs)
	if (locale === "hr") return hr_other_support_heading(inputs)
	if (locale === "it") return it_other_support_heading(inputs)
	if (locale === "lv") return lv_other_support_heading(inputs)
	if (locale === "lt") return lt_other_support_heading(inputs)
	if (locale === "hu") return hu_other_support_heading(inputs)
	if (locale === "nl") return nl_other_support_heading(inputs)
	if (locale === "nb") return nb_other_support_heading(inputs)
	if (locale === "pl") return pl_other_support_heading(inputs)
	if (locale === "pt") return pt_other_support_heading(inputs)
	if (locale === "ro") return ro_other_support_heading(inputs)
	if (locale === "sk") return sk_other_support_heading(inputs)
	if (locale === "sl") return sl_other_support_heading(inputs)
	if (locale === "fi") return fi_other_support_heading(inputs)
	if (locale === "sv") return sv_other_support_heading(inputs)
	if (locale === "vi") return vi_other_support_heading(inputs)
	if (locale === "tr") return tr_other_support_heading(inputs)
	if (locale === "el") return el_other_support_heading(inputs)
	if (locale === "bg") return bg_other_support_heading(inputs)
	if (locale === "ru") return ru_other_support_heading(inputs)
	if (locale === "sr") return sr_other_support_heading(inputs)
	if (locale === "uk") return uk_other_support_heading(inputs)
	if (locale === "ka") return ka_other_support_heading(inputs)
	if (locale === "hi") return hi_other_support_heading(inputs)
	if (locale === "th") return th_other_support_heading(inputs)
	if (locale === "ko") return ko_other_support_heading(inputs)
	if (locale === "zh") return zh_other_support_heading(inputs)
	if (locale === "zh-tw") return zh_tw_other_support_heading(inputs)
	if (locale === "ja") return ja_other_support_heading(inputs)
	return en_other_support_heading(inputs)
});